<template>
  <div class="background" id="aaa">
    <div class="title">全屏测试</div>
    <div @click="screen" class="full" >全屏
    </div>
  </div>
</template>
<script>

  export default {
    name: "FullScreen",
    data() {
      return {
        //默认不全屏
        fullscreen: document.fullscreen,
      };
    },
    mounted () {
      //在mounted调用
      this.noSleep();
    },
    methods: {
      //屏幕常亮
      noSleep () {
        let noSleep = new this.$NoSleep();
        document.addEventListener('click',
          function enableNoSleep () {
            noSleep.enable();
            document.removeEventListener('click', enableNoSleep, false);
          },
          false);
      },
      screen(){
        // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
        let element = document.getElementById('aaa');//设置后就是   id==con_lf_top_div 的容器全屏
        if (document.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
        // this.fullscreen = !this.fullscreen;

      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .background{
    height: 100%;
    width: 100%;
    position: absolute;
    background-size:cover;
    background-position: center;
  }

  .title{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 16%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .full {
    opacity:0.8;
    border-radius:10px;
    background: #FFF;
    position: absolute;
    width: 20%;
    height: 50px;
    top: 75%;
    left: 40%;
    color: rgb(61, 50, 39);
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/FullScreen.vue